import { render } from "./indexFourClient.vue?vue&type=template&id=bf6d72dc"
import script from "./indexFourClient.vue?vue&type=script&lang=js"
export * from "./indexFourClient.vue?vue&type=script&lang=js"

import "./indexFourClient.vue?vue&type=style&index=0&id=bf6d72dc&lang=css"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__